import { render, staticRenderFns } from "./PriceInfo21.vue?vue&type=template&id=41d87576&scoped=true"
import script from "./PriceInfo21.vue?vue&type=script&lang=js"
export * from "./PriceInfo21.vue?vue&type=script&lang=js"
import style0 from "./PriceInfo21.vue?vue&type=style&index=0&id=41d87576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d87576",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fprice-info-21%2FPriceInfo21.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports